module.exports = __webpack_public_path__ + "static/media/im_errorimage.8fe1fa3c.png";